<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="payroll.taxForms.records" [menuService]="payrollModuleMenuService"></app-header>

    <div class="flex justify-space-between align-items-center padding-bottom-3">
        <mat-form-field class="no-labels no-helpers">
            <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange()">
                <mat-option *ngFor="let year of taxFormYears" [value]="year">{{ year }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div>{{ 'payroll.taxForms.craBusinessNumber' | translate }}{{ craBusinessNumber }}</div>
    </div>

    <app-table
        [table]="employerPackageTable"
        [title]="'payroll.taxForms.employerPackage' | translate"
        [showSearch]="false"
        [useStickyHeader]="false"
        [showOffset]="false"
    >
        <div class="empty flex col justify-center align-items-center">
            <span class="padding-y-3">{{
                'payroll.taxForms.pleaseEnsureThatAllInformationIsUpToDate' | translate
            }}</span>
            <ui-button
                (click)="generateT4s(selectedYear)"
                [disabled]="!enableT4ForTaxYear && selectedYear === currentTaxSeason"
                class="padding-y-3"
                type="primary"
                >{{ 'payroll.taxForms.generateT4s' | translate: { year: selectedYear } }}
            </ui-button>
        </div>
        <div
            class="flex justify-center padding-bottom-3"
            *ngIf="!enableT4ForTaxYear && selectedYear === currentTaxSeason"
        >
            {{ 'payroll.taxForms.ourSystemCannotYetGenerateT4sFor' | translate: { year: currentTaxSeason } }}
        </div>
    </app-table>
</div>
